import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  Row,
  Col,
  Form,
  FloatingLabel,
  Image,
  Card,
  Container,
} from "react-bootstrap";
import AppNav from "../../../header/AppNav";

function EditPatientsHistory() {
  //Diagnosis start
  const [diagnosis, setDiagnosis] = useState({ Cataract: false });
  const handleDiagnosisChange = (e) => {
    setDiagnosis({ ...diagnosis, [e.target.name]: e.target.checked });
  };
  //Diagnosis end
  //Cataract Check box start
  const [selectedOption, setSelectedOption] = useState("");
  const [performed, setPerformed] = useState("");
  //Cataract checkbox start

  //Glaucoma start
  const [applanationTonometry, setApplanationTonometry] = useState(false);

  const handleApplanationChange = (e) => {
    setApplanationTonometry(e.target.checked);
  };
  const [selectedGlaucomaOption, setSelectedGlaucomaOption] = useState("");
  const [selectedProcedureDone, setSelectedProcedureDone] = useState("");
  const [selectedGlaucomaSurgeryType, setSelectedGlaucomaSurgeryType] =
    useState("");
  const [selectedTrabeculectomy, setSelectedTrabeculectomy] = useState("");
  const [selectedGDSurgeryOthers, setSelectedGDSurgeryOthers] = useState("");
  const [selectedDrFundusExam, setSelectedDrFundusExam] = useState("");
  const [selectedDrGrading, setSelectedDrGrading] = useState("");
  const [selectedDrStage, setSelectedDrStage] = useState("");
  const [selectedDrHospital, setSelectedDrHospital] = useState("");
  const [selectedDrTreatment, setSelectedDrTreatment] = useState("");
  const [selectedDrProcedure, setSelectedDrProcedure] = useState("");
  const [selectedDrIvrProcedure, setSelectedDrIvrProcedure] = useState("");
  const [selectedDrSurgery, setSelectedDrSurgery] = useState("");
  //Glaucoma start

  //   const navigate = useNavigate();
  //   const [loading, setLoading] = useState(false);
  //   const [taluks, setTaluks] = useState({
  //     id: undefined,
  //     taluk: "",
  //   });
  //   const [error, setError] = useState({
  //     taluk: "",
  //   });

  //   const validation = () => {
  //     let tempError = {
  //       taluk: "",
  //     };
  //     let valid = true;
  //     if (!taluks.taluk) {
  //       tempError.taluk = "Taluk is required";
  //       valid = false;
  //     }
  //     setError(tempError);
  //     return valid;
  //   };

  //   const update = async () => {
  //     if (validation()) {
  //       setLoading(true);
  //       try {
  //         const res = await TalukServices.updateTaluk({
  //           ...taluks,
  //         });
  //         if (res.status === 200) {
  //           alert(res.message);
  //           onHide();
  //           navigate("/taluk");
  //         } else {
  //           alert("Error while updating");
  //         }
  //         setLoading(false);
  //       } catch (error) {
  //         alert(error.message);
  //         setLoading(false);
  //       }
  //     }
  //   };

  //   useEffect(() => {
  //     if (show) {
  //       setTaluks({
  //         id: taluk.id,
  //         taluk: taluk.taluk,
  //       });
  //     }
  //   }, [show]);
  return (
    <>
      <AppNav />
      <h1 className="list-style">Today's Patient List</h1>
      <Container>
        <Card>
          <Card.Body>
            <Row>
              <Col>
                <FloatingLabel
                  controlId="editPatientName"
                  label="Patient Name*"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Patient Name*"
                    //   value={taluks.taluk}
                    //   onChange={(e) => setTaluks({ ...taluks, taluk: e.target.value })}
                    //   isInvalid={!!error.taluk}
                  />
                  {/* <p className="required-field-meassage">{error.taluk}</p> */}
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editPatientId"
                  label="Patient Id*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Patient Id*" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editGender"
                  label="Gender*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Gender*" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editAge"
                  label="Age*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Age*" />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <FloatingLabel
                  controlId="editMobno"
                  label="Mobile no*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Mobile no*" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editAadharno"
                  label="Aadhar No*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Aadhar No*" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editAshaName"
                  label="Asha Name*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Asha Name*" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editAshaBlock"
                  label="Asha Block*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Asha Block*" />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <FloatingLabel
                  controlId="editAddress"
                  label="Address*"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Address*"
                    as="textarea"
                    style={{ height: "100px" }}
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <FloatingLabel
                  controlId="editInsurance"
                  label="Insurance*"
                  className="mb-3"
                >
                  <Form.Control type="text" placeholder="Insurance*" />
                </FloatingLabel>
              </Col>
              <Col>
                <FloatingLabel
                  controlId="editEyeDonation"
                  label="Intrested in Eye Donation*"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Intrested in Eye Donation*"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <br />
            <Row className="display-flex">
              <Col>
                <h5>Patient Diagnosis:</h5>
                {["checkbox"].map((type) => (
                  <div key={`inline-${type}`} className="mb-3">
                    <Form.Check
                      inline
                      label="Cataract"
                      name="Cataract"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={diagnosis.Cataract}
                      onChange={handleDiagnosisChange}
                    />
                    <Form.Check
                      inline
                      label="Glaucoma"
                      name="Glaucoma"
                      type={type}
                      id={`inline-${type}-2`}
                      checked={diagnosis.Glaucoma}
                      onChange={handleDiagnosisChange}
                    />
                    <Form.Check
                      inline
                      label="Diabetic retinopathy"
                      name="DiabeticRetinopathy"
                      type={type}
                      id={`inline-${type}-3`}
                      checked={diagnosis.DiabeticRetinopathy}
                      onChange={handleDiagnosisChange}
                    />
                    <Form.Check
                      inline
                      label="Other Conditions"
                      name="OtherConditions"
                      type={type}
                      id={`inline-${type}-4`}
                      checked={diagnosis.OtherConditions}
                      onChange={handleDiagnosisChange}
                    />
                  </div>
                ))}
              </Col>
            </Row>
            <Row>
              {diagnosis.Cataract && (
                <Container>
                  <FloatingLabel controlId="editCataract" label="Cataract*">
                    <Form.Select
                      aria-label="Cataract*"
                      onChange={(e) => setSelectedOption(e.target.value)}
                    >
                      <option>Open this select menu</option>
                      <option value="Surgery">Surgery</option>
                      <option value="RequireFollowUp">Require Follow up</option>
                      <option value="PatientDidNotTurnUp">
                        Patient did not turn up
                      </option>
                    </Form.Select>
                  </FloatingLabel>

                  {/* If Surgery is selected */}
                  {selectedOption === "Surgery" && (
                    <div className="mt-3 display-flex">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        name="performed"
                        value="Yes"
                        onChange={(e) => setPerformed(e.target.value)}
                      />
                      <Form.Check
                        className="spacing-left"
                        type="radio"
                        label="No"
                        name="performed"
                        value="No"
                        onChange={(e) => setPerformed(e.target.value)}
                      />
                    </div>
                  )}
                  {performed === "Yes" && (
                    <FloatingLabel
                      controlId="editFollowUpDate"
                      label="Follow Up Date*"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Follow Up Date"
                        className="mt-2"
                      />
                    </FloatingLabel>
                  )}

                  {performed === "No" && (
                    <Form.Select aria-label="Reason" className="mt-2">
                      <option>Select</option>
                      <option value="Immature">Immature</option>
                      <option value="NCD">NCD</option>
                      <option value="Others">Others</option>
                    </Form.Select>
                  )}

                  {/* If Required to Follow Up is selected */}
                  {selectedOption === "RequireFollowUp" && (
                    <div className="mt-3 display-flex">
                      <Form.Check
                        type="radio"
                        label="After 6 months"
                        name="After6Months"
                        value="After6Months"
                      />
                      <Form.Check
                        className="spacing-left"
                        type="radio"
                        label="After 1 year"
                        name="After1Year"
                        value="After1Year"
                      />
                    </div>
                  )}

                  {/* If Patient Didnt Turn Up is selected */}
                  {selectedOption === "PatientDidNotTurnUp" && (
                    <FloatingLabel
                      controlId="editReason"
                      label="Reason*"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason"
                        className="mt-2"
                      />
                    </FloatingLabel>
                  )}
                </Container>
              )}
              {diagnosis.Glaucoma && (
                <Container>
                  <FloatingLabel controlId="editGlaucoma" label="Glaucoma*">
                    <Form.Select
                      aria-label="Glaucoma*"
                      onChange={(e) => setSelectedOption(e.target.value)}
                    >
                      <option>Select</option>
                      <option value="TestConducted">Test conducted</option>
                      <option value="PatientTurnUp">Patient turn up</option>
                      <option value="GlaucomaDiagnosed">
                        Glaucoma Diagnosed
                      </option>
                    </Form.Select>
                  </FloatingLabel>
                  {/* If Test Conducted is selected */}
                  {selectedOption === "TestConducted" && (
                    <div className="mt-3 display-flex">
                      <Form.Check
                        type="checkbox"
                        label="Applanation Tonometry"
                        name="performed"
                        value="ApplanationTonometry"
                        checked={applanationTonometry}
                        onChange={handleApplanationChange}
                      />
                      <Form.Check
                        className="spacing-left"
                        type="checkbox"
                        label="Fundus Examination"
                        name="performed"
                        value="FundusExamination"
                      />
                      <Form.Check
                        className="spacing-left"
                        type="checkbox"
                        label="Gonioscopy"
                        name="performed"
                        value="Gonioscopy"
                      />
                      <Form.Check
                        className="spacing-left"
                        type="checkbox"
                        label="HFA"
                        name="performed"
                        value="HFA"
                      />
                      <Form.Check
                        className="spacing-left"
                        type="checkbox"
                        label="Glaucoma OCT"
                        name="performed"
                        value="GlaucomaOCT"
                      />
                      <Form.Check
                        className="spacing-left"
                        type="checkbox"
                        label="Others"
                        name="performed"
                        value="Others"
                      />
                    </div>
                  )}
                  {applanationTonometry && (
                    <div className="mt-3 display-flex">
                      <Form.Check
                        type="radio"
                        label="Left Eye"
                        name="EyeSelection"
                        value="LeftEye"
                      />
                      <Form.Check
                        className="spacing-left"
                        type="radio"
                        label="Right Eye"
                        name="EyeSelection"
                        value="RightEye"
                      />
                    </div>
                  )}
                  {selectedOption === "PatientTurnUp" && (
                    <div className="mt-3 display-flex">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        name="performed"
                        value="PatientTurnUpYes"
                        // onChange={(e) => setPerformed(e.target.value)}
                      />
                      <Form.Check
                        className="spacing-left"
                        type="radio"
                        label="No"
                        name="performed"
                        value="PatientTurnUpNo"
                        // onChange={(e) => setPerformed(e.target.value)}
                      />
                    </div>
                  )}
                  {selectedOption === "GlaucomaDiagnosed" && (
                    <div className="mt-3 ">
                      <div className="display-flex">
                        <Form.Check
                          type="radio"
                          label="Yes"
                          name="performed"
                          value="GlaucomaDiagnosedYes"
                          onChange={(e) => setPerformed(e.target.value)}
                        />
                        <Form.Check
                          className="spacing-left"
                          type="radio"
                          label="No"
                          name="performed"
                          value="GlaucomaDiagnosedNo"
                          onChange={(e) => setPerformed(e.target.value)}
                        />
                      </div>

                      {performed === "GlaucomaDiagnosedNo" && (
                        <div className="display-flex">
                          <h5>Follow Up</h5>
                          <Form.Check
                            type="radio"
                            label="After 6 months"
                            name="performed"
                            value="After6months"
                            // onChange={(e) => setPerformed(e.target.value)}
                          />
                          <Form.Check
                            className="spacing-left"
                            type="radio"
                            label="After 1 year"
                            name="performed"
                            value="After1year"
                            // onChange={(e) => setPerformed(e.target.value)}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {performed === "GlaucomaDiagnosedYes" && (
                    <FloatingLabel
                      controlId="GlaucomaDiagnosedYesDropdown"
                      label="Selects"
                    >
                      <Form.Select
                        aria-label="Select"
                        onChange={(e) =>
                          setSelectedGlaucomaOption(e.target.value)
                        }
                      >
                        <option>Select menu</option>
                        <option value="PrescribedMedication">
                          Prescribed medication
                        </option>
                        <option value="LaserRx">Laser Rx</option>
                        <option value="GlaucomaSurgery">Surgery</option>
                        <option value="GlaucomaFollowUp">Follow up</option>
                      </Form.Select>
                    </FloatingLabel>
                  )}
                  {selectedGlaucomaOption === "PrescribedMedication" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="Medication"
                          label="Medication"
                        >
                          <Form.Select aria-label="Medication">
                            <option>Open this select menu</option>
                            <option value="Timolol">Timolol</option>
                            <option value="Latanoprost">Latanoprost</option>
                            <option value="Dorzolamide">Dorzolamide</option>
                            <option value="Others - To specify">
                              Others - To specify
                            </option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="FollowUpLocation"
                          label="Follow Up Location"
                        >
                          <Form.Select aria-label="Floating label select example">
                            <option>Open this select menu</option>
                            <option value="SIMS">SIMS</option>
                            <option value="AllGHNames">All GH names</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col className="display-flex">
                        <p>Date of follow up</p>
                        <div className="follow-up-left">
                          <Form.Check
                            type="radio"
                            label="After 15 days"
                            name="After15days"
                            value="After15days"
                            // onChange={(e) => setPerformed(e.target.value)}
                          />
                          <Form.Check
                            type="radio"
                            label="After 30 days"
                            name="After30days"
                            value="After30days"
                            // onChange={(e) => setPerformed(e.target.value)}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  {selectedGlaucomaOption === "LaserRx" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="dateOfAdmission "
                          label="Date of Admission"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Date of Admission"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="ProcedureDone"
                          label="Procedure Done"
                        >
                          <Form.Select
                            aria-label="ProcedureDone"
                            onChange={(e) =>
                              setSelectedProcedureDone(e.target.value)
                            }
                          >
                            <option>Open this select menu</option>
                            <option value="ProcedureDoneYes">Yes</option>
                            <option value="ProcedureDoneNo">No</option>
                            <option value="ProcedureDonePatientDidNotTurnUp">
                              Patient did not turn up
                            </option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedProcedureDone === "ProcedureDoneYes" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="followUpDate"
                          label="Follow Up Date"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Follow Up Date"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="Medication"
                          label="Medication"
                        >
                          <Form.Select aria-label="Medication">
                            <option>Open this select menu</option>
                            <option value="Timolol">Timolol</option>
                            <option value="Latanoprost">Latanoprost</option>
                            <option value="Dorzolamide">Dorzolamide</option>
                            <option value="Others - To specify">
                              Others - To specify
                            </option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}

                  {selectedProcedureDone === "ProcedureDoneNo" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="reasonForRefusal"
                          label="Reason for refusal"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Reason for refusal"
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedProcedureDone ===
                    "ProcedureDonePatientDidNotTurnUp" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="reasonForRefusal"
                          label="Reason for refusal"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Reason for refusal"
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedGlaucomaOption === "GlaucomaSurgery" && (
                    <FloatingLabel controlId="SurgeryType" label="Surgery Type">
                      <Form.Select
                        aria-label="Surgery Type"
                        onChange={(e) =>
                          setSelectedGlaucomaSurgeryType(e.target.value)
                        }
                      >
                        <option>Open this select menu</option>
                        <option value="Trabeculectomy">Trabeculectomy</option>
                        <option value="GlaucomaSurgeryTypeOthers">
                          Others
                        </option>
                      </Form.Select>
                    </FloatingLabel>
                  )}
                  {selectedGlaucomaSurgeryType === "Trabeculectomy" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="datepfAdmission"
                          label="Date of Admission"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Date of Admission"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="TrabeculectomyProcedure"
                          label="Procudre Done"
                        >
                          <Form.Select
                            aria-label="TrabeculectomyProcedure"
                            onChange={(e) =>
                              setSelectedTrabeculectomy(e.target.value)
                            }
                          >
                            <option>Open this select menu</option>
                            <option value="TrabeculectomyProcedureYes">
                              Yes
                            </option>
                            <option value="TrabeculectomyProcedureNo">
                              No
                            </option>
                            <option value="TrabeculectomyProcedureDiNotTurnUp">
                              Patient did not turn up
                            </option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedTrabeculectomy === "TrabeculectomyProcedureYes" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="followUpDate"
                          label="Follow Up Date"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Follow Up Date"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="Medication"
                          label="Medication"
                        >
                          <Form.Select aria-label="Medication">
                            <option>Open this select menu</option>
                            <option value="Timolol">Timolol</option>
                            <option value="Latanoprost">Latanoprost</option>
                            <option value="Dorzolamide">Dorzolamide</option>
                            <option value="Others - To specify">
                              Others - To specify
                            </option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}

                  {selectedTrabeculectomy === "TrabeculectomyProcedureNo" && (
                    <FloatingLabel
                      controlId="reasonForRefusal"
                      label="Reason for refusal"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason for refusal"
                      />
                    </FloatingLabel>
                  )}
                  {selectedTrabeculectomy ===
                    "TrabeculectomyProcedureDiNotTurnUp" && (
                    <FloatingLabel
                      controlId="reasonForRefusal"
                      label="Reason for refusal"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason for refusal"
                      />
                    </FloatingLabel>
                  )}

                  {selectedGlaucomaSurgeryType ===
                    "GlaucomaSurgeryTypeOthers" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="datepfAdmission"
                          label="Date of Admission"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Date of Admission"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="TrabeculectomyProcedure"
                          label="Procudre Done"
                        >
                          <Form.Select
                            aria-label="TrabeculectomyProcedure"
                            onChange={(e) =>
                              setSelectedGDSurgeryOthers(e.target.value)
                            }
                          >
                            <option>Open this select menu</option>
                            <option value="TrabeculectomyProcedureYes">
                              Yes
                            </option>
                            {/* <option value="TrabeculectomyProcedureNo">
                              No
                            </option>
                            <option value="TrabeculectomyProcedureDiNotTurnUp">
                              Patient did not turn up
                            </option> */}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedGDSurgeryOthers === "TrabeculectomyProcedureYes" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="followUpDate"
                          label="Follow Up Date"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Follow Up Date"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="Medication"
                          label="Medication"
                        >
                          <Form.Select aria-label="Medication">
                            <option>Open this select menu</option>
                            <option value="Timolol">Timolol</option>
                            <option value="Latanoprost">Latanoprost</option>
                            <option value="Dorzolamide">Dorzolamide</option>
                            <option value="Others - To specify">
                              Others - To specify
                            </option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedGlaucomaOption === "GlaucomaFollowUp" && (
                    <Row>
                      <Col>
                        <Form.Check
                          type="radio"
                          label="After 6 months"
                          name="After6months"
                          value="After6months"
                          //   onChange={(e) => setPerformed(e.target.value)}
                        />
                        <Form.Check
                          type="radio"
                          label="After 1 year"
                          name="After1year"
                          value="After 1 year"
                          //   onChange={(e) => setPerformed(e.target.value)}
                        />
                      </Col>
                    </Row>
                  )}
                </Container>
              )}
              {diagnosis.DiabeticRetinopathy && (
                <Container>
                  <div className="mt-3 display-flex">
                    <h5>Patient turn up: </h5>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="performed"
                      value="Yes"
                      onChange={(e) => setPerformed(e.target.value)}
                    />
                    <Form.Check
                      className="spacing-left"
                      type="radio"
                      label="No"
                      name="performed"
                      value="No"
                      onChange={(e) => setPerformed(e.target.value)}
                    />
                  </div>
                  {performed === "No" && (
                    <FloatingLabel
                      controlId="editReason"
                      label="Reason*"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason"
                        className="mt-2"
                      />
                    </FloatingLabel>
                  )}
                  {performed === "Yes" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="editTestConducted"
                          label="TestConducted*"
                          className="mb-3"
                        >
                          <Form.Select
                            aria-label="TestConducted"
                            className="mt-2"
                            onChange={(e) =>
                              setSelectedDrFundusExam(e.target.value)
                            }
                          >
                            <option>Select</option>
                            <option value="fundusExamination">
                              Fundus examination
                            </option>
                            <option value="oct">OCT</option>
                            <option value="ffa">FFA</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="editGrading"
                          label="Grading*"
                          className="mb-3"
                          onChange={(e) => setSelectedDrGrading(e.target.value)}
                        >
                          <Form.Select aria-label="Grading" className="mt-2">
                            <option>Select</option>
                            <option value="npdr">NPDR</option>
                            <option value="pdr">PDR</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedDrFundusExam === "fundusExamination" &&
                    selectedDrGrading === "npdr" && (
                      <FloatingLabel
                        controlId="editStage"
                        label="Stage*"
                        className="mb-3"
                      >
                        <Form.Select
                          aria-label="Stage"
                          className="mt-2"
                          onChange={(e) => setSelectedDrStage(e.target.value)}
                        >
                          <option>Select</option>
                          <option value="stageOne">1</option>
                          <option value="stageTwo">2</option>
                          <option value="stageThree">3</option>
                          <option value="stageFour">4</option>
                        </Form.Select>
                      </FloatingLabel>
                    )}
                  {selectedDrStage && (
                    <FloatingLabel
                      controlId="editHospitalReferred"
                      label="Hospital Referred*"
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label="Hospital Referred"
                        className="mt-2"
                        onChange={(e) => setSelectedDrHospital(e.target.value)}
                      >
                        <option>Select</option>
                        <option value="shankara">Shankara</option>
                        <option value="sims">SIMS</option>
                      </Form.Select>
                    </FloatingLabel>
                  )}
                  {selectedDrHospital && (
                    <Row>
                      <Col>
                        <Col>
                          <FloatingLabel
                            controlId="dateOfAdmission"
                            label="Date of Admission"
                            className="mb-3"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Date of Admission"
                            />
                          </FloatingLabel>
                        </Col>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="editTreatmentAdvised"
                          label="Treatment Advised*"
                          className="mb-3"
                        >
                          <Form.Select
                            aria-label="Treatment Advised"
                            className="mt-2"
                            onChange={(e) =>
                              setSelectedDrTreatment(e.target.value)
                            }
                          >
                            <option>Select</option>
                            <option value="laserRx">Laser Rx</option>
                            <option value="intraVitrealInjections">
                              Intra vitreal injections
                            </option>
                            <option value="surgery">Surgery</option>
                            <option value="medication">Medication</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedDrTreatment === "laserRx" && (
                    <FloatingLabel
                      controlId="editProcedureDone"
                      label="Procedure Done*"
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label="Procedure Done"
                        className="mt-2"
                        onChange={(e) => setSelectedDrProcedure(e.target.value)}
                      >
                        <option>Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                        <option value="didntTurnUp">
                          Patient did not turn up
                        </option>
                      </Form.Select>
                    </FloatingLabel>
                  )}
                  {selectedDrProcedure === "yes" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="followUpDate"
                          label="Follow Up Date"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Follow Up Date"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="prescribedMedication"
                          label="Prescribed Medication"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Prescribed Medication"
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedDrProcedure === "no" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="followUpDate"
                          label="Follow Up Date"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Follow Up Date"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="prescribedMedication"
                          label="Prescribed Medication"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Prescribed Medication"
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedDrProcedure === "didntTurnUp" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="followUpDate"
                          label="Follow Up Date"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Follow Up Date"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="reason"
                          label="Reason"
                          className="mb-3"
                        >
                          <Form.Control type="text" placeholder="reason" />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}{" "}
                  {selectedDrTreatment === "intraVitrealInjections" && (
                    <FloatingLabel
                      controlId="editProcedureDone"
                      label="Procedure Done*"
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label="Procedure Done"
                        className="mt-2"
                        onChange={(e) =>
                          setSelectedDrIvrProcedure(e.target.value)
                        }
                      >
                        <option>Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                        <option value="didntTurnUp">
                          Patient did not turn up
                        </option>
                      </Form.Select>
                    </FloatingLabel>
                  )}
                  {selectedDrIvrProcedure === "yes" && (
                    <FloatingLabel
                      controlId="followUpDate"
                      label="Follow Up Date"
                      className="mb-3"
                    >
                      <Form.Control type="text" placeholder="Follow Up Date" />
                    </FloatingLabel>
                  )}
                  {selectedDrIvrProcedure === "no" && (
                    <FloatingLabel
                      controlId="reasonForRefusal"
                      label="Reason for Refusal"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason for Refusal"
                      />
                    </FloatingLabel>
                  )}
                  {selectedDrIvrProcedure === "didntTurnUp" && (
                    <FloatingLabel
                      controlId="reasonForRefusal"
                      label="Reason for Refusal"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason for Refusal"
                      />
                    </FloatingLabel>
                  )}
                  {selectedDrTreatment === "surgery" && (
                    <FloatingLabel
                      controlId="editProcedureDone"
                      label="Procedure Done*"
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label="Procedure Done"
                        className="mt-2"
                        onChange={(e) => setSelectedDrSurgery(e.target.value)}
                      >
                        <option>Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                        <option value="didntTurnUp">
                          Patient did not turn up
                        </option>
                      </Form.Select>
                    </FloatingLabel>
                  )}
                  {selectedDrSurgery === "yes" && (
                    <FloatingLabel
                      controlId="followUpDate"
                      label="Follow Up Date"
                      className="mb-3"
                    >
                      <Form.Control type="text" placeholder="Follow Up Date" />
                    </FloatingLabel>
                  )}
                  {selectedDrSurgery === "no" && (
                    <Row>
                      <Col>
                        <FloatingLabel
                          controlId="reasonForRefusal"
                          label="Reason for Refusal"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Reason for Refusal"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col>
                        <FloatingLabel
                          controlId="prescribed Medication"
                          label="Prescribed Medication"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Prescribed Medication"
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  )}
                  {selectedDrSurgery === "didntTurnUp" && (
                    <FloatingLabel
                      controlId="reasonForRefusal"
                      label="Reason for Refusal"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Reason for Refusal"
                      />
                    </FloatingLabel>
                  )}
                  {selectedDrTreatment === "medication" && (
                    <FloatingLabel
                      controlId="specifyMedication"
                      label="Specify Medication"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Specify Medication"
                      />
                    </FloatingLabel>
                  )}
                </Container>
              )}
              {diagnosis.OtherConditions && (
                <Row>
                  <Col>
                    <FloatingLabel
                      controlId="diagnosis"
                      label="Diagnosis"
                      className="mb-3"
                    >
                      <Form.Control type="text" placeholder="Diagnosis" />
                    </FloatingLabel>
                  </Col>
                  <Col>
                    <FloatingLabel
                      controlId="treatment"
                      label="Treatment"
                      className="mb-3"
                    >
                      <Form.Control type="text" placeholder="Treatment" />
                    </FloatingLabel>
                  </Col>
                </Row>
              )}
            </Row>
          </Card.Body>
        </Card>
        <br />
        <br />
        <br />
      </Container>
    </>
  );
}

export default EditPatientsHistory;
